import axios from 'axios'
import * as pureAxios from 'axios'
import config from './config'
import util from './util'
import router from '../router/index'
import qs from 'qs'
import { getFatianshiTokenByLoacl } from '@/libs/fatianshi'
const whitelist = ['/tpi/quanweidu/enterprise/info', '/wechat/open/js-api-config']
axios.defaults.withCredentials = true// 让ajax携带cookie
axios.defaults.timeout = 10 * 1000 * 6 * 10 // 超时

axios.interceptors.request.use(
  config => {
    const token = window.localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    if (/authentication/.test(config.url) || /openwechat/.test(config.url)) {
      let str = ''
      if (process.env.NODE_ENV == 'development') {
        str = 'c2VydmljZV9sYXd5ZXI6REVWIzI0MjAkYWRpcCNs'
        // str = 'c2VydmljZV9sYXd5ZXI6UUEjMjQyMCRhZGlwI2w='
        // str = 'c2VydmljZV9sYXd5ZXI6UFJPRCMyNDIwJGFkaXAjbA=='
      } else if (process.env.type == 'test' && process.env.NODE_ENV == 'production') {
        str = 'c2VydmljZV9sYXd5ZXI6UUEjMjQyMCRhZGlwI2w='
      } else {
        // 生产环境
        str = 'c2VydmljZV9sYXd5ZXI6UFJPRCMyNDIwJGFkaXAjbA=='
      }
      //

      config.headers['Authorization'] = 'Basic ' + str

      config.headers['osType'] = 1
      config.headers['appVer'] = 300
      config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    }
    if (config.url === 'https://tsapi.fatianshi.cn/File/GenerateDocx') {
      config.headers['Authorization'] = `Bearer ${getFatianshiTokenByLoacl()}`
    }
    return config
  }
  //   err => {
  //      return Promise.reject(err)
  //   }
)

axios.interceptors.response.use(
  async (response) => {
    if (response.data.code === 1000) {
      router.push({ path: '/login' })
    } else if (response.data.code === 1001) {
      // 重刷token
      const flag = await util.refreshToken()
      if (flag == 1) {
        return axios.request(response.config)
      }
    } /* else if (response.data.code === 10000) {
      Message.error('操作失败！')
      return response
    } */ else {
      return response
    }
  },
  err => {
    if (err.response) {
      if (err.response.status === 401 || err.response.status === 400) {
        router.push({ path: '/login' })
      } else if (err.response.status === 500 || err.response.status === 503) {
        if (whitelist.indexOf(err.response.data.path) == -1) {
          router.push({ path: '/500' })
        }
      }
    }
    // return Promise.reject(err)
  }
)

export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(config.baseUrl + url, {
      params: params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'indices', allowDots: true })
      }
    })
      .then(res => {
        if (res) { resolve(res.data) }
      })
      .catch(err => {
        reject(err)
      })
  })
}

export function post(url, params, headers = {}) {
  const header = JSON.stringify(headers) == '{}' ? config.headers : headers
  return new Promise((resolve, reject) => {
    axios.post(config.baseUrl + url,
      params,
      {
        header
      }
    )
      .then(res => {
        if (res) { resolve(res.data) }
      })
      .catch(err => {
        reject(err)
      })
  })
}

export function patch(url, params, headers = {}) {
  const header = JSON.stringify(headers) == '{}' ? config.headers : headers
  return new Promise((resolve, reject) => {
    axios.patch(config.baseUrl + url,
      params,
      {
        header
      }
    )
      .then(res => {
        resolve(res.data || '')
      })
      .catch(err => {
        reject(err)
      })
  })
}

export function del(url, params, headers = {}) {
  const header = JSON.stringify(headers) == '{}' ? config.headers : headers
  return new Promise((resolve, reject) => {
    axios.delete(config.baseUrl + url,
      params,
      {
        header
      }
    )
      .then(res => {
        if (res) { resolve(res.data) }
      })
      .catch(err => {
        reject(err)
      })
  })
}

export function put(url, params, headers = {}) {
  const header = JSON.stringify(headers) == '{}' ? config.headers : headers
  return new Promise((resolve, reject) => {
    axios.put(config.baseUrl + url,
      params,
      {
        header
      }
    )
      .then(res => {
        if (res) { resolve(res.data) }
      })
      .catch(err => {
        reject(err)
      })
  })
}

export function exportGet(url, params, headers = {}) {
  const header = JSON.stringify(headers) == '{}' ? config.headers : headers
  return new Promise((resolve, reject) => {
    axios({
      method: 'GET',
      headers: header,
      url: config.baseUrl + url,
      params: params,
      paramsSerializer: params => {
        return qs.stringify(params, { indices: false })
      },
      responseType: 'blob'
    }).then(res => {
      // 截取文件名
      console.log('res', res)
      console.log('content-disposition', res.headers['content-disposition'])
      let fileName = res.headers['content-disposition'] ? decodeURI(res.headers['content-disposition'].split(';')[1].split('=')[1]) : '导出文件.xlsx'
      fileName = fileName.replace(/\"/g, '')
      // 将`blob`对象转化成一个可访问的`url`
      const url = window.URL.createObjectURL(new Blob([res.data]))
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      URL.revokeObjectURL(link.url) // 释放URL 对象
      document.body.removeChild(link)

      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}
// 特殊情况
export function specialExportGet(url, params, headers = {}) {
  const header = JSON.stringify(headers) == '{}' ? config.headers : headers
  return new Promise((resolve, reject) => {
    axios({
      method: 'GET',
      headers: header,
      url: config.baseUrl + url,
      params: params,
      paramsSerializer: params => {
        console.log('222222', qs.stringify(params, { indices: false }))
        return qs.stringify(params, { arrayFormat: 'indices', allowDots: true })
      },
      responseType: 'blob'
    }).then(res => {
      // 截取文件名
      console.log('res', res)
      console.log('content-disposition', res.headers['content-disposition'])
      let fileName = res.headers['content-disposition'] ? decodeURI(res.headers['content-disposition'].split(';')[1].split('=')[1]) : '导出文件.xlsx'
      fileName = fileName.replace(/\"/g, '')
      // 将`blob`对象转化成一个可访问的`url`
      const url = window.URL.createObjectURL(new Blob([res.data]))
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      URL.revokeObjectURL(link.url) // 释放URL 对象
      document.body.removeChild(link)

      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

export function exportPost(url, params, headers = {}, suffix = 'xlsx') {
  const header = JSON.stringify(headers) == '{}' ? config.headers : headers
  return new Promise((resolve, reject) => {
    axios({
      method: 'POST',
      headers: header,
      url: config.baseUrl + url,
      data: params,
      paramsSerializer: params => {
        return qs.stringify(params, { indices: false })
      },
      responseType: 'blob'
    }).then(res => {
      console.log(res)
      // 截取文件名
      let fileName = res.headers['content-disposition'] ? decodeURI(res.headers['content-disposition'].split(';')[1].split('=')[1]) : `导出文件.${suffix}`
      fileName = fileName.replace(/\"/g, '')
      // 将`blob`对象转化成一个可访问的`url`
      const url = window.URL.createObjectURL(new Blob([res.data]))
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      URL.revokeObjectURL(link.url) // 释放URL 对象
      document.body.removeChild(link)

      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

// 待办跟催导出
export function exportFollow(url, params, headers = {}) {
  const header = JSON.stringify(headers) == '{}' ? config.headers : headers
  return new Promise((resolve, reject) => {
    axios({
      method: 'GET',
      headers: header,
      url: config.baseUrl + url,
      params: params,
      paramsSerializer: params => {
        return qs.stringify(params, { indices: false, arrayFormat: 'indices', allowDots: true })
      },
      responseType: 'blob'
    }).then(res => {
      // 截取文件名
      let fileName = res.headers['content-disposition'] ? decodeURI(res.headers['content-disposition'].split(';')[1].split('=')[1]) : '导出文件.xlsx'
      fileName = fileName.replace(/\"/g, '')
      // 将`blob`对象转化成一个可访问的`url`
      const url = window.URL.createObjectURL(new Blob([res.data]))
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      URL.revokeObjectURL(link.url) // 释放URL 对象
      document.body.removeChild(link)

      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

export function postFormData(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.post(config.baseUrl + url,
      params,
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'application/json'
        }
      }
    )
      .then(res => {
        if (res) { resolve(res.data) }
      })
      .catch(err => {
        reject(err)
      })
  })
}

export function getTencentFile(url) {
  // 纯净的 axios 实例，没有统一添加拦截器和请求头
  // return pureAxios.get(config.getTencentFilePath + url, { responseType: 'blob' })
  return pureAxios({
    method: 'GET',
    responseType: 'blob',
    url: config.getTencentFilePath + url
  })
}



// WEBPACK FOOTER //
// ./src/libs/axios.js